<template>
    <v-container style="padding: 16px;">
        <v-row
            v-if="!$vuetify.breakpoint.xs"
            class="m-0"
        >
            <v-col>
                <v-data-table
                    id="main_response_history_table"
                    ref="main_response_history_table"
                    fixed-header
                    :headers="headers"
                    :items="getTicketPositiveResponseLog"
                    item-key="key"
                    hide-default-footer                          
                >
                    <template v-slot:item.details="{item}">
                        <v-icon
                            class="mr-2 material-icons-outlined"
                            @click="showDetails(item)"
                        >
                            info
                        </v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-col
            v-if="$vuetify.breakpoint.xs"
            id="ticket-response-history-cards"
        >
            <v-card
                v-for="item in getTicketPositiveResponseLog"
                :key="item.rowid"
                flat
                tile
            >
                <table class="px-3 py-4">
                    <tr>
                        <td>Date:</td>
                        <td>{{ item.posresp_date }}</td>
                    </tr>
                    <tr>
                        <td>Code:</td>
                        <td>{{ item.terminal_code }}</td>
                    </tr>
                    <tr>
                        <td>Center/811 Response:</td>
                        <td>{{ item.posresp_audit }}</td>
                    </tr>
                </table>
                <v-icon
                    class="material-icons-outlined"
                    @click="showDetails(item)"
                >
                    info
                </v-icon>
            </v-card>
        </v-col>
        <v-dialog
            v-model="dialog"
            width="400"
        >
            <v-card>
                <v-card-title class="text-subtitle-1 py-3 pl-5">
                    Positive Response Properties
                </v-card-title>
                <v-divider />

                <v-card-text>
                    <v-card
                        flat
                        tile
                    >
                        <table class="ticket-response-details">
                            <tr>
                                <td>Member Code : </td>
                                <td>{{ responseDetails ? responseDetails.terminal_code : '-' }}</td>
                            </tr>
                            <tr>
                                <td>Response Code : </td>
                                <td>{{ responseDetails ? responseDetails.response_code : '-' }}</td>
                            </tr>
                            <tr>
                                <td>+Response Code : </td>
                                <td>{{ responseDetails ? responseDetails.posresp_code : '-' }}</td>
                            </tr>
                            <tr>
                                <td>Queued Date : </td>
                                <td>{{ responseDetails ? responseDetails.posresp_queued : '-' }}</td>
                            </tr>
                            <tr>
                                <td>Sent Date : </td>
                                <td>{{ responseDetails ? responseDetails.posresp_date : '-' }}</td>
                            </tr>
                            <tr>
                                <td>Audit : </td>
                                <td>{{ responseDetails ? responseDetails.posresp_audit : '-' }}</td>
                            </tr>
                        </table>
                    </v-card>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        outlined
                        color="indigo"
                        class="text-transform-none dialog-action-btn mr-2 text-capitalize"
                        @click="closedDetailsScreen()"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import moment from 'moment';

export default {
    name: 'ResponseHistory',
    data: () => ({
        dialog: false,
        responseDetails: null,
        headers: [
            {
                text: 'Date',
                value: 'posresp_date',
                align: 'left',
                width: '80px',
                sortable: false,
            },
            {
                text: 'Code',
                value: 'terminal_code',
                align: 'left',
                width: '80px',
                sortable: false,
            },
            {
                text: 'Center/811 Response',
                value: 'posresp_audit',
                align: 'left',
                width: '80px',
                sortable: false,
            },
            {
                text: 'Details',
                value: 'details',
                align: 'center',
                width: '80px',
                sortable: false,
            },
        ],
    }),
    computed: {
        getTicketDetails() {
            return this.$store.getters.ticketDetails;
        },
        getTicketPositiveResponseLog() {
            if(this.getTicketDetails && this.getTicketDetails?.Ticket_PositiveResponseLog) {
                return this.getTicketDetails.Ticket_PositiveResponseLog.map((item) => {
                    item.posresp_date = moment(item.posresp_date).format(' DD MMM YYYY, hh:mm A');
                    item.posresp_queued = moment(item.posresp_queued).format(' DD MMM YYYY, hh:mm A');
                    return item;
                });
            } else {
                return [];
            }
        },
    },
    methods: {
        showDetails(item) {
            this.responseDetails = item;
            this.dialog = true;
        },
        closedDetailsScreen() {
            this.responseDetails = null;
            this.dialog = false;
        }
    }
};
</script>

<style>
    #main_response_history_table.v-data-table {
        border: 1px solid var(--ll-border);
        width: 100%;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
        overflow: hidden;
    }
    #main_response_history_table.v-data-table__wrapper {
        border-radius: 4px;
    }
    #main_response_history_table .v-data-table-header th{
        background: var(--ll-surface-subtle) !important;
    }
    .ticket-response_history-container {
        display: flex;
        justify-content: space-between !important;
    }

    #ticket-response-history-cards {
        padding: 0px 12px;
    }
    #ticket-response-history-cards .v-card {
        border-bottom: 1px solid #d3d5d8;
    }
    #ticket-response-history-cards .v-card {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }
    #ticket-response-history-cards .ticket-card-info {
        border-radius: 4px;
        border: 1px solid var(--ll-border-subtle);
        height: 28px;
        display: inline-block;
        min-width: 40px;
        margin-top: 16px;
        margin-bottom: 16px;
        margin-right: 8px;
        padding: 4px 8px;
        color: var(--ll-text-primary);
        font-size: 12px;
    }
    #ticket-response-history-cards table {
        font-size: 12px;
        width: 100%;
    }
    #ticket-response-history-cards table tr td:first-child {
        width: 100px;
    }
    #ticket-response-history-cards table tr td:nth-child(2) {
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 0;
    }
    #ticket-response-history-cards .status-open-chip {
        margin-right: 10px;
    }
    .ticket-response-details {
        padding: 0px;
        margin: 0px;
    }
    .ticket-response-details tr td:first-child {
        font-family: 'Roboto';
        font-style: normal;
        width: 110px;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.004em;
        color: var(--ll-text-primary);
    }
    .ticket-response-details tr td:nth-child(2) {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 32px;
        letter-spacing: 0.02em;
        text-transform: uppercase;
        color: var(--ll-text-primary);
    }
</style>
